import i18n from '@i18n';
import {
    format,
    formatDistanceToNow,
    isToday,
    isTomorrow,
    isYesterday,
    isThisYear,
    subMonths,
    isThisMinute,
    isThisHour,
    differenceInMinutes,
    isThisWeek,
} from 'date-fns';

import { he } from 'date-fns/locale';
import { t } from 'i18next';
const lang = i18n.language;
const formatOptions = lang === 'he' ? { locale: he } : undefined;

// ===== FOR TESTING ===== //
function test() {
    function getFormattedLocalDateWithOffset(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const milliseconds =
            String(date.getMilliseconds()).padStart(3, '0') + '000';

        const tzOffset = -date.getTimezoneOffset();
        const tzOffsetHours = Math.floor(Math.abs(tzOffset) / 60)
            .toString()
            .padStart(2, '0');
        const tzOffsetMinutes = (Math.abs(tzOffset) % 60)
            .toString()
            .padStart(2, '0');
        const tzOffsetString = `${tzOffset >= 0 ? '+' : '-'}${tzOffsetHours}:${tzOffsetMinutes}`;

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds.substring(0, 6)}${tzOffsetString}`;
    }

    // Create array of dates at specified intervals
    let now = new Date();
    let dates = [
        now,
        new Date(now - 5 * 60 * 1000), // 5 minutes ago
        new Date(now - 56 * 60 * 1000), // 56 minutes ago
        new Date(now - 2 * 60 * 60 * 1000), // 2 hours ago
        new Date(now - 24 * 60 * 60 * 1000), // 24 hours ago
        new Date(now - 48 * 60 * 60 * 1000), // 48 hours ago
        new Date(now - 7 * 24 * 60 * 60 * 1000), // 7 days ago
        new Date(now.setMonth(now.getMonth() - 3)), // 3 months ago
        new Date(now.setFullYear(now.getFullYear() - 1)), // last year
    ];

    // Format all dates
    let formattedDates = dates.map(getFormattedLocalDateWithOffset);
    formattedDates.forEach(date => {
        console.log(date.toFriendlyDateTime());
    });
}
// =============== END OF TESTING =============== //

export const getContextualDateTime = date => {
    if (!date) return '';
    const dateObj = new Date(date);

    if (isToday(dateObj)) {
        return `${t('Today')} • ${format(dateObj, 'HH:mm')}`;
    } else if (isYesterday(dateObj)) {
        return `${t('Yesterday')} • ${format(dateObj, 'HH:mm')}`;
    } else if (isTomorrow(dateObj)) {
        return `${t('Tomorrow')} • ${format(dateObj, 'HH:mm')}`;
    } else if (isThisYear(dateObj)) {
        return `${format(dateObj, 'MMM d', formatOptions)} • ${format(dateObj, 'HH:mm')}`;
    } else {
        return `${dateObj.toLocaleDateString()} • ${format(dateObj, 'HH:mm')}`;
    }
};

export const getFriendlyDateTime = date => {
    if (!date) return '';
    const dateObj = new Date(date);
    const now = new Date();

    if (differenceInMinutes(now, dateObj) === 0) {
        return t('now');
    } else if (differenceInMinutes(now, dateObj) < 60) {
        return `${differenceInMinutes(now, dateObj)} ${t('min')}`;
    } else if (isToday(dateObj)) {
        return format(dateObj, 'HH:mm');
    } else if (isYesterday(dateObj)) {
        return `${t('Yesterday')} ${format(dateObj, 'HH:mm')}`;
    } else if (isThisWeek(dateObj)) {
        return format(dateObj, 'EE HH:mm');
    } else if (isThisYear(dateObj)) {
        return format(dateObj, 'dd MMM HH:mm', formatOptions);
    } else {
        return format(dateObj, 'dd MMM yyyy HH:mm', formatOptions);
    }
};
